// extracted by mini-css-extract-plugin
export default {"pagination_search":"Pagination_pagination_search__GkliA"};